import script from "./BookingRealComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingRealComponent.vue?vue&type=script&setup=true&lang=js"

import "./BookingRealComponent.vue?vue&type=style&index=0&id=ba608e72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba608e72"]])

export default __exports__